import { Box, IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

export const COLUMNS = ({ toggleExpand, onRowClick }: any) => {
  let cols: any[] = [
    {
      header: 'Name',
      accessorKey: 'name',
      enableColumnFilter: false,
      cell: (info: any) => (
        <Box
          className="column-holder"
          style={{
            paddingLeft: `${(info.row.original.level || 0) * 20}px`,
            display: 'flex',
            alignItems: 'center',
            height: '25px',
            width: '100%',
          }}
          onClick={() => onRowClick(info.row.original.id)}
        >
          {info.row.original.children?.length > 0 ? (
            <IconButton
              onClick={e => {
                e.stopPropagation();
                toggleExpand(info.row.original.id);
              }}
              style={{ marginRight: '1px', color: '#939393' }}
            >
              {info.row.original.isExpanded ? (
                <RemoveIcon sx={{ width: '15px', height: '15px' }} />
              ) : (
                <AddIcon sx={{ width: '15px', height: '15px' }} />
              )}
            </IconButton>
          ) : (
            <div style={{ width: '32px' }} />
          )}
          {info.getValue()}
        </Box>
      ),
    },
    {
      header: 'Dot number',
      accessorKey: 'dotNumber',
      enableColumnFilter: false,
      cell: (info: any) => (
        <Box
          className="column-holder"
          sx={{ alignContent: 'center', width: '100%' }}
          onClick={() => onRowClick(info.row.original.id)}
        >
          {info.getValue()}
        </Box>
      ),
    },
    {
      header: 'ID',
      accessorKey: 'id',
      enableColumnFilter: false,
      cell: (info: any) => (
        <Box
          className="column-holder"
          sx={{ alignContent: 'center', width: '100%' }}
          onClick={() => onRowClick(info.row.original.id)}
        >
          {info.getValue()}
        </Box>
      ),
    },
    {
      header: 'Status',
      accessorKey: 'is_active',
      enableColumnFilter: false,
      accessorFn: (originalRow: any) =>
        `${originalRow.isActive ? 'Active' : 'Not active'}`,
      cell: (info: any) => (
        <Box
          className="column-holder"
          sx={{ alignContent: 'center', width: '100%' }}
          onClick={() => onRowClick(info.row.original.id)}
        >
          {info.getValue()}
        </Box>
      ),
    },
  ];

  return cols;
};
